/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description Renter Hub user menu section
 */

import * as React from 'react'
import { TRACK_USER_MENU_ACTION } from '../../../constants'
import { useUserMenuContext } from '../../../module/context/UserMenuContext'
import type { RenterHubProps } from '../../../types'
import { NavbarBadge } from '../../NavbarBadge'
import { MenuSection, UserMenuBtnRow, UserMenuLinkRow } from '../SharedComponents'

export const RenterHub = ({
  isMessage3,
  unreadCount,
  handleSetActiveSubmenu,
}: Omit<RenterHubProps, 'menuClick'>) => {
  const { dispatchTrackUserMenuClick, isLoggedIn, toolsActivated } = useUserMenuContext()

  const onFavoritesClick = () => dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.FAVORITES)
  const onApplicationsClick = () => dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.APPLICATIONS)

  const onSavedSearchesClick = () =>
    dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.SAVED_SEARCHES)

  const onProfileClick = () => dispatchTrackUserMenuClick(TRACK_USER_MENU_ACTION.PROFILE)

  const onResourcesClick = () => handleSetActiveSubmenu({}, 'smResources')
  const isProUser = isLoggedIn && toolsActivated
  return (
    <MenuSection heading="Renter hub">
      {isLoggedIn && isMessage3 && (
        <UserMenuLinkRow href="/messages">
          Messages
          {!!unreadCount && <NavbarBadge text={unreadCount > 99 ? '99+' : `${unreadCount}`} />}
        </UserMenuLinkRow>
      )}
      <UserMenuLinkRow href="/favorites" onClick={onFavoritesClick}>
        Favorites
      </UserMenuLinkRow>
      {isLoggedIn && (
        <UserMenuLinkRow href="/alerts" onClick={onSavedSearchesClick}>
          Saved searches
        </UserMenuLinkRow>
      )}
      <UserMenuLinkRow href="/apply" onClick={onApplicationsClick}>
        Applications
      </UserMenuLinkRow>
      {isLoggedIn && (
        <UserMenuLinkRow href={`${isProUser ? '/manage' : ''}/settings`} onClick={onProfileClick}>
          Profile
        </UserMenuLinkRow>
      )}
      <UserMenuBtnRow onClick={onResourcesClick}>Renting resources</UserMenuBtnRow>
    </MenuSection>
  )
}
